/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface NGPayment
 */
export class NGPayment {
    /**
     *
     * @type {string}
     * @memberof NGPayment
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof NGPayment
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof NGPayment
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof NGPayment
     */
    merchantKey: string;
    /**
     *
     * @type {string}
     * @memberof NGPayment
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof NGPayment
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof NGPayment
     */
    autoApprove: boolean;
}
